// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { CalculateNewData, CalculateNewErrors, CalculateNewResponses, CreateDeviceRuleData, CreateDeviceRuleErrors, CreateDeviceRuleResponses, CreateNetworkQualityScheduleData, CreateNetworkQualityScheduleErrors, CreateNetworkQualityScheduleResponses, DeleteDeviceData, DeleteDeviceErrors, DeleteDeviceResponses, DeleteDeviceRuleData, DeleteDeviceRuleErrors, DeleteDeviceRuleResponses, DeleteNetworkQualityScheduleData, DeleteNetworkQualityScheduleErrors, DeleteNetworkQualityScheduleResponses, GetConfigurationListData, GetConfigurationListErrors, GetConfigurationListResponses, GetDeviceCapabilitiesData, GetDeviceCapabilitiesErrors, GetDeviceCapabilitiesResponses, GetDeviceData, GetDeviceErrors, GetDeviceListData, GetDeviceListErrors, GetDeviceListResponses, GetDeviceResponses, GetDeviceRuleData, GetDeviceRuleErrors, GetDeviceRuleResponses, GetDeviceSettingsCapabilitiesData, GetDeviceSettingsCapabilitiesErrors, GetDeviceSettingsCapabilitiesResponses, GetLatestData, GetLatestErrors, GetLatestResponses, GetNetworkQualityScheduleData, GetNetworkQualityScheduleErrors, GetNetworkQualityScheduleResponses, GetRootDeviceListData, GetRootDeviceListErrors, GetRootDeviceListResponses, GetSearchFiltersData, GetSearchFiltersErrors, GetSearchFiltersResponses, ListDeviceReadableDataPointsData, ListDeviceReadableDataPointsErrors, ListDeviceReadableDataPointsResponses, ListDeviceRulesData, ListDeviceRulesErrors, ListDeviceRulesExtData, ListDeviceRulesExtErrors, ListDeviceRulesExtResponses, ListDeviceRulesResponses, ListDeviceWritableDataPointsData, ListDeviceWritableDataPointsErrors, ListDeviceWritableDataPointsResponses, LookupDeviceAccountDetailsData, LookupDeviceAccountDetailsErrors, LookupDeviceAccountDetailsResponses, PatchDeviceData, PatchDeviceErrors, PatchDeviceResponses, PostDeviceCapabilitiesData, PostDeviceCapabilitiesErrors, PostDeviceCapabilitiesResponses, PutDeviceCapabilitiesData, PutDeviceCapabilitiesErrors, PutDeviceCapabilitiesResponses, ReplaceGatewayData, ReplaceGatewayErrors, ReplaceGatewayResponses, SearchDevicesData, SearchDevicesErrors, SearchDevicesResponses, SoftwareResetData, SoftwareResetErrors, SoftwareResetResponses, UpdateDeviceRuleData, UpdateDeviceRuleErrors, UpdateDeviceRuleResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get the list of device configurations for the installation.
 */
export const getConfigurationList = <ThrowOnError extends boolean = false>(options: Options<GetConfigurationListData, ThrowOnError>): RequestResult<GetConfigurationListResponses, GetConfigurationListErrors, ThrowOnError> => (options.client ?? client).get<GetConfigurationListResponses, GetConfigurationListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/configuration',
    ...options
});

/**
 * Get the capabilities of a specific device.
 */
export const getDeviceCapabilities = <ThrowOnError extends boolean = false>(options: Options<GetDeviceCapabilitiesData, ThrowOnError>): RequestResult<GetDeviceCapabilitiesResponses, GetDeviceCapabilitiesErrors, ThrowOnError> => (options.client ?? client).get<GetDeviceCapabilitiesResponses, GetDeviceCapabilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/capabilities/{deviceType}',
    ...options
});

/**
 * Get the settings capabilities of a specific device.
 */
export const getDeviceSettingsCapabilities = <ThrowOnError extends boolean = false>(options: Options<GetDeviceSettingsCapabilitiesData, ThrowOnError>): RequestResult<GetDeviceSettingsCapabilitiesResponses, GetDeviceSettingsCapabilitiesErrors, ThrowOnError> => (options.client ?? client).get<GetDeviceSettingsCapabilitiesResponses, GetDeviceSettingsCapabilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/capabilities/settings',
    ...options
});

/**
 * Create the capabilities of a specific device.
 */
export const postDeviceCapabilities = <ThrowOnError extends boolean = false>(options: Options<PostDeviceCapabilitiesData, ThrowOnError>): RequestResult<PostDeviceCapabilitiesResponses, PostDeviceCapabilitiesErrors, ThrowOnError> => (options.client ?? client).post<PostDeviceCapabilitiesResponses, PostDeviceCapabilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/capabilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the capabilities of a specific device.
 */
export const putDeviceCapabilities = <ThrowOnError extends boolean = false>(options: Options<PutDeviceCapabilitiesData, ThrowOnError>): RequestResult<PutDeviceCapabilitiesResponses, PutDeviceCapabilitiesErrors, ThrowOnError> => (options.client ?? client).put<PutDeviceCapabilitiesResponses, PutDeviceCapabilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/capabilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of root devices for the installation.
 */
export const getRootDeviceList = <ThrowOnError extends boolean = false>(options: Options<GetRootDeviceListData, ThrowOnError>): RequestResult<GetRootDeviceListResponses, GetRootDeviceListErrors, ThrowOnError> => (options.client ?? client).get<GetRootDeviceListResponses, GetRootDeviceListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices',
    ...options
});

/**
 * Get the list of sub-devices for a specific device.
 */
export const getDeviceList = <ThrowOnError extends boolean = false>(options: Options<GetDeviceListData, ThrowOnError>): RequestResult<GetDeviceListResponses, GetDeviceListErrors, ThrowOnError> => (options.client ?? client).get<GetDeviceListResponses, GetDeviceListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/devices',
    ...options
});

/**
 * Delete a specific device.
 */
export const deleteDevice = <ThrowOnError extends boolean = false>(options: Options<DeleteDeviceData, ThrowOnError>): RequestResult<DeleteDeviceResponses, DeleteDeviceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDeviceResponses, DeleteDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}',
    ...options
});

/**
 * Get the details of a specific device.
 */
export const getDevice = <ThrowOnError extends boolean = false>(options: Options<GetDeviceData, ThrowOnError>): RequestResult<GetDeviceResponses, GetDeviceErrors, ThrowOnError> => (options.client ?? client).get<GetDeviceResponses, GetDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}',
    ...options
});

/**
 * Update a specific device.
 */
export const patchDevice = <ThrowOnError extends boolean = false>(options: Options<PatchDeviceData, ThrowOnError>): RequestResult<PatchDeviceResponses, PatchDeviceErrors, ThrowOnError> => (options.client ?? client).patch<PatchDeviceResponses, PatchDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace the gateway of a specific device.
 */
export const replaceGateway = <ThrowOnError extends boolean = false>(options: Options<ReplaceGatewayData, ThrowOnError>): RequestResult<ReplaceGatewayResponses, ReplaceGatewayErrors, ThrowOnError> => (options.client ?? client).post<ReplaceGatewayResponses, ReplaceGatewayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/gateway/replace',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new rule for a specific device.
 */
export const createDeviceRule = <ThrowOnError extends boolean = false>(options: Options<CreateDeviceRuleData, ThrowOnError>): RequestResult<CreateDeviceRuleResponses, CreateDeviceRuleErrors, ThrowOnError> => (options.client ?? client).post<CreateDeviceRuleResponses, CreateDeviceRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/devicetwin/{deviceTwinId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a specific rule for a specific device.
 */
export const deleteDeviceRule = <ThrowOnError extends boolean = false>(options: Options<DeleteDeviceRuleData, ThrowOnError>): RequestResult<DeleteDeviceRuleResponses, DeleteDeviceRuleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDeviceRuleResponses, DeleteDeviceRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/{ruleId}',
    ...options
});

/**
 * Get the details of a specific rule for a specific device.
 */
export const getDeviceRule = <ThrowOnError extends boolean = false>(options: Options<GetDeviceRuleData, ThrowOnError>): RequestResult<GetDeviceRuleResponses, GetDeviceRuleErrors, ThrowOnError> => (options.client ?? client).get<GetDeviceRuleResponses, GetDeviceRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/{ruleId}',
    ...options
});

/**
 * Update a specific rule for a specific device.
 */
export const updateDeviceRule = <ThrowOnError extends boolean = false>(options: Options<UpdateDeviceRuleData, ThrowOnError>): RequestResult<UpdateDeviceRuleResponses, UpdateDeviceRuleErrors, ThrowOnError> => (options.client ?? client).put<UpdateDeviceRuleResponses, UpdateDeviceRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/{ruleId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all rules for a specific device.
 */
export const listDeviceRules = <ThrowOnError extends boolean = false>(options: Options<ListDeviceRulesData, ThrowOnError>): RequestResult<ListDeviceRulesResponses, ListDeviceRulesErrors, ThrowOnError> => (options.client ?? client).get<ListDeviceRulesResponses, ListDeviceRulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/list/{deviceTwinId}',
    ...options
});

/**
 * List all outgoing and incomings rules for a specific device.
 */
export const listDeviceRulesExt = <ThrowOnError extends boolean = false>(options: Options<ListDeviceRulesExtData, ThrowOnError>): RequestResult<ListDeviceRulesExtResponses, ListDeviceRulesExtErrors, ThrowOnError> => (options.client ?? client).get<ListDeviceRulesExtResponses, ListDeviceRulesExtErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/listext/{deviceTwinId}',
    ...options
});

/**
 * List all readable data points for a specific device.
 */
export const listDeviceReadableDataPoints = <ThrowOnError extends boolean = false>(options: Options<ListDeviceReadableDataPointsData, ThrowOnError>): RequestResult<ListDeviceReadableDataPointsResponses, ListDeviceReadableDataPointsErrors, ThrowOnError> => (options.client ?? client).get<ListDeviceReadableDataPointsResponses, ListDeviceReadableDataPointsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/datapoints/readable/{deviceTwinId}',
    ...options
});

/**
 * List all writable data points for a specific device.
 */
export const listDeviceWritableDataPoints = <ThrowOnError extends boolean = false>(options: Options<ListDeviceWritableDataPointsData, ThrowOnError>): RequestResult<ListDeviceWritableDataPointsResponses, ListDeviceWritableDataPointsErrors, ThrowOnError> => (options.client ?? client).get<ListDeviceWritableDataPointsResponses, ListDeviceWritableDataPointsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/rules/datapoints/writable/{deviceTwinId}',
    ...options
});

/**
 * Search for devices based on the provided search parameters.
 */
export const searchDevices = <ThrowOnError extends boolean = false>(options?: Options<SearchDevicesData, ThrowOnError>): RequestResult<SearchDevicesResponses, SearchDevicesErrors, ThrowOnError> => (options?.client ?? client).get<SearchDevicesResponses, SearchDevicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/devices/search',
    ...options
});

/**
 * Lookup account details for a specific device.
 */
export const lookupDeviceAccountDetails = <ThrowOnError extends boolean = false>(options: Options<LookupDeviceAccountDetailsData, ThrowOnError>): RequestResult<LookupDeviceAccountDetailsResponses, LookupDeviceAccountDetailsErrors, ThrowOnError> => (options.client ?? client).get<LookupDeviceAccountDetailsResponses, LookupDeviceAccountDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/devices/search/lookup/{deviceTwinId}',
    ...options
});

/**
 * Get the available search filters for devices.
 */
export const getSearchFilters = <ThrowOnError extends boolean = false>(options?: Options<GetSearchFiltersData, ThrowOnError>): RequestResult<GetSearchFiltersResponses, GetSearchFiltersErrors, ThrowOnError> => (options?.client ?? client).get<GetSearchFiltersResponses, GetSearchFiltersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/devices/search/filters',
    ...options
});

/**
 * Get the latest health score for a specific device.
 */
export const getLatest = <ThrowOnError extends boolean = false>(options: Options<GetLatestData, ThrowOnError>): RequestResult<GetLatestResponses, GetLatestErrors, ThrowOnError> => (options.client ?? client).get<GetLatestResponses, GetLatestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/healthscore/latest',
    ...options
});

/**
 * Calculate a new health score for a specific device.
 */
export const calculateNew = <ThrowOnError extends boolean = false>(options: Options<CalculateNewData, ThrowOnError>): RequestResult<CalculateNewResponses, CalculateNewErrors, ThrowOnError> => (options.client ?? client).post<CalculateNewResponses, CalculateNewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/healthscore/calculate',
    ...options
});

/**
 * Delete the network quality schedule for a specific device.
 */
export const deleteNetworkQualitySchedule = <ThrowOnError extends boolean = false>(options: Options<DeleteNetworkQualityScheduleData, ThrowOnError>): RequestResult<DeleteNetworkQualityScheduleResponses, DeleteNetworkQualityScheduleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteNetworkQualityScheduleResponses, DeleteNetworkQualityScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/network-quality/schedule',
    ...options
});

/**
 * Get the network quality schedule for a specific device.
 */
export const getNetworkQualitySchedule = <ThrowOnError extends boolean = false>(options: Options<GetNetworkQualityScheduleData, ThrowOnError>): RequestResult<GetNetworkQualityScheduleResponses, GetNetworkQualityScheduleErrors, ThrowOnError> => (options.client ?? client).get<GetNetworkQualityScheduleResponses, GetNetworkQualityScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/network-quality/schedule',
    ...options
});

/**
 * Create a new network quality schedule for a specific device.
 */
export const createNetworkQualitySchedule = <ThrowOnError extends boolean = false>(options: Options<CreateNetworkQualityScheduleData, ThrowOnError>): RequestResult<CreateNetworkQualityScheduleResponses, CreateNetworkQualityScheduleErrors, ThrowOnError> => (options.client ?? client).post<CreateNetworkQualityScheduleResponses, CreateNetworkQualityScheduleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/network-quality/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Perform a software reset on a specific device.
 */
export const softwareReset = <ThrowOnError extends boolean = false>(options: Options<SoftwareResetData, ThrowOnError>): RequestResult<SoftwareResetResponses, SoftwareResetErrors, ThrowOnError> => (options.client ?? client).post<SoftwareResetResponses, SoftwareResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/installations/{installationId}/devices/{deviceTwinId}/softwarereset',
    ...options
});
